// Rails entry point — `react_component 'Invoices/SendInvoiceModal', { ... }`.
//
// The implementation lives in SendInvoiceModalView.tsx (NOT named after the
// directory): webpack's require.context resolution treats a sibling file named
// after its parent directory as a self-import, yielding an undefined export at
// runtime (see the sibling QboTaxPrecheck for the same gotcha).
import React, { useEffect, useState } from 'react';
import SendInvoiceModalView from './SendInvoiceModalView';
export { default as SendInvoiceModal } from './SendInvoiceModalView';
export default function Index({ triggerIds = [], openOnLoad = false, invoiceId, customerEmail, subject, body, pdfPath, hasLatestReport, defaultAttachPdf, defaultBccMe, onSent, dismissElementId }) {
    const [isOpen, setIsOpen] = useState(openOnLoad);
    // Rails hands a fresh array on every render; key the effect on its contents.
    const triggerKey = triggerIds.join(',');
    const handleSent = () => {
        if (dismissElementId) {
            const callout = document.getElementById(dismissElementId);
            if (callout)
                callout.hidden = true;
        }
        onSent === null || onSent === void 0 ? void 0 : onSent();
    };
    useEffect(() => {
        const onClick = (event) => {
            event.preventDefault();
            setIsOpen(true);
        };
        const triggers = triggerKey
            .split(',')
            .filter(Boolean)
            .map((id) => document.getElementById(id))
            .filter((el) => el !== null);
        triggers.forEach((trigger) => trigger.addEventListener('click', onClick));
        return () => triggers.forEach((trigger) => trigger.removeEventListener('click', onClick));
    }, [triggerKey]);
    return (React.createElement(SendInvoiceModalView, { invoiceId: invoiceId, customerEmail: customerEmail, subject: subject, body: body, pdfPath: pdfPath, hasLatestReport: hasLatestReport, defaultAttachPdf: defaultAttachPdf, defaultBccMe: defaultBccMe, onSent: handleSent, isOpen: isOpen, onClose: () => setIsOpen(false) }));
}
